/** URL slug: fold accents so "plomería" → "plomeria" (not "plomera"). */
export const slugify = (text: string): string => {
  return text
    ?.toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

/** Previous slugify (dropped accents instead of folding). Used to match old URLs like /service/plomera. */
export const legacySlugify = (text: string): string => {
  return text
    ?.toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

export function serviceNameMatchesSlug(
  name: string | undefined | null,
  slug: string
): boolean {
  if (!name || !slug) return false;
  return slugify(name) === slug || legacySlugify(name) === slug;
}

/** Match a service object against a URL slug using name / mlname. */
export function serviceMatchesSlug(service: any, slug: string): boolean {
  if (!service || !slug) return false;
  const names = [
    service.name,
    service.mlname?.en,
    service.mlname?.es,
    typeof service.mlname === "string" ? service.mlname : null,
  ].filter(Boolean) as string[];
  return names.some((name) => serviceNameMatchesSlug(name, slug));
}

/** Find a service inside category[].services by URL slug. */
export function findServiceBySlugInCategories(
  categories: any[] | undefined | null,
  slug: string
): any | null {
  if (!categories?.length || !slug) return null;
  for (const category of categories) {
    const services = category?.services;
    if (!Array.isArray(services)) continue;
    const found = services.find((service: any) =>
      serviceMatchesSlug(service, slug)
    );
    if (found) return found;
  }
  return null;
}
